import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Bullet.svg",
  "use": "Bullet.svg-usage",
  "viewBox": "0 0 5 5",
  "content": "<symbol viewBox=\"0 0 5 5\" fill-rule=\"evenodd\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Bullet.svg\">\n<circle cx=\"2.5\" cy=\"2.5\" r=\"2.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol